import React from 'react';
import { Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';

interface DateRestrictionProps {
  targetDate: Date;
  children: React.ReactNode;
}

const DateRestriction: React.FC<DateRestrictionProps> = ({ targetDate, children }) => {
  const now = new Date();
  const isLocked = now < targetDate;

  if (isLocked) {
    return (
      <div className="min-h-screen py-12 px-4 flex items-center justify-center">
        <motion.div 
          className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex justify-center mb-6">
            <div className="bg-wedding-blue-100 p-4 rounded-full">
              <Lock size={48} className="text-wedding-blue-600" />
            </div>
          </div>
          
          <h2 className="text-2xl font-playfair font-semibold text-wedding-blue-800 mb-4">
            Conteúdo Bloqueado
          </h2>
          
          <p className="text-gray-700 mb-6">
            O álbum de fotos estará disponível somente a partir do dia do casamento.
          </p>
          
          <div className="w-24 h-0.5 bg-wedding-beige-400 mx-auto mb-6"></div>
          
          <p className="text-wedding-blue-700 font-medium">
            Retorne em {targetDate.toLocaleDateString('pt-BR')}
          </p>
        </motion.div>
      </div>
    );
  }

  return <>{children}</>;
};

export default DateRestriction;